export default __webpack_public_path__ + "consigner-app-static/media/error.9091695b.svg";